class HeaderSearchButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('a[href]');
    this.header = this.closest('.sp-header-custom');
    this.dropdown = this.header?.querySelector('.sp-header-custom__search-dropdown');
    this.input = this.dropdown?.querySelector('.sp-header-custom__search-input');
    this.closeButton = this.dropdown?.querySelector('.sp-header-custom__search-close');
    this.results = this.dropdown?.querySelector('.sp-header-custom__search-results');
    this.form = this.dropdown?.querySelector('form');
    if (!this.button || !this.dropdown || !this.input || !this.results) return;

    this.button.addEventListener('click', this.toggle);
    this.closeButton?.addEventListener('click', this.close);
    this.input.addEventListener('input', this.search);
    this.form?.addEventListener('submit', this.prepareSubmit);
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.closeButton?.removeEventListener('click', this.close);
    this.input?.removeEventListener('input', this.search);
    this.form?.removeEventListener('submit', this.prepareSubmit);
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeydown);
    this.abortController?.abort();
    clearTimeout(this.searchTimer);
  }

  toggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.dropdown.hidden) this.open();
    else this.close();
  };

  open = () => {
    this.dropdown.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => this.input.focus());
  };

  close = () => {
    if (this.dropdown.hidden) return;
    this.dropdown.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    this.abortController?.abort();
    this.button.focus();
  };

  handleOutsideClick = (event) => {
    if (!this.dropdown.hidden && !this.header.contains(event.target)) this.close();
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && !this.dropdown.hidden) this.close();
  };

  prepareSubmit = (event) => {
    if (!this.input.value.trim()) event.preventDefault();
  };

  search = () => {
    clearTimeout(this.searchTimer);
    this.abortController?.abort();
    const query = this.input.value.trim();
    if (!query) {
      this.results.replaceChildren();
      return;
    }
    this.searchTimer = setTimeout(() => this.fetchResults(query), 200);
  };

  async fetchResults(query) {
    this.abortController = new AbortController();
    this.results.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(`${window.Shopify?.routes?.root || '/'}search/suggest`, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('section_id', 'sp-predictive-search');
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const newResults = documentFragment.querySelector('[data-sp-predictive-results]');
      if (this.input.value.trim() === query) this.results.innerHTML = newResults?.innerHTML || '';
    } catch (error) {
      if (error.name !== 'AbortError') this.results.replaceChildren();
    } finally {
      this.results.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('search-button')) customElements.define('search-button', HeaderSearchButton);
